import React from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import styles from './InHomeServiceSection.module.scss';

interface InHomeServiceSectionProps {
    inHomeService: boolean;
    onChange: (inHomeService: boolean) => void;
}

export const InHomeServiceSection: React.FC<InHomeServiceSectionProps> = ({ inHomeService, onChange }) => {
    return (
        <div className={styles.container}>
            <Switch
                label="In-Home Service"
                inlineLabel="Toggle on if you provide in-home training"
                checked={inHomeService}
                onChange={onChange}
            />
        </div>
    );
};
